module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA7klEQVRIie2WoQ7CMBCGvxKCACQKNIRkD4DGEgQe7F6Fl8CCwiAIHskDYEAzhUQRwsjCEkp3XdqB3G+aXu7+r9cmuyl0HeMRsADa+CsCQgK10ytNwMVivgKu2r4FTIW8iEB19EDVSLCdvA/ctH3TkpepNwGJ7sABeFpMSGF7bV8BBkDNBbAGZjnmNi2la6sIyY8C5tY6CfBXlYASUAJkgBJiLhLrpG/RBNgUAAyloDkP4mKH1xSoL0+fNzgB83R1lk8HPeAMdHMhP3TQSNe6TwfSI9uUDPMtMPYBuA59V2WGvnlFYfr7Ucz8Xf8R8AJNVykjm0gESQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/902/details_phone_nunber.png
// module id = oltE
// module chunks = 1